<template>
  <div class="confirmation">
    <div v-if="status === 'processing'" class="success" v-html="$t('payment.processing_payment')"></div>
    <div v-if="status === 'success'" class="success" v-html="$t('payment.success_payment')"></div>
    <div v-if="status === 'receiver'" v-html="$t('payment.receiver_payment')"></div>
    <div v-if="status === 'error'" class="error">
      <div v-html="$t('payment.payment_error')"></div>
      <p class="error-message">
        {{ errorMessage }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentConfirmation',
  props: {
    status: {
      type: String,
      default: null,
      validator: value => ['processing', 'success', 'receiver', 'error', null].includes(value)
    },
    errorMessage: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.confirmation {
  > div {
    margin: 20px 0;
    padding: 20px 0;
  }

  .success {
    background: #eefbf1;
    border: 1px solid #c3e6cb;
    padding: 20px 10px;
  }

  .error {
    color: red;

    .error-message {
      margin-top: 10px;
    }
  }
}
</style>